import { e_meterAlertsConstant } from "./e_meter_alerts_constants";

export const e_meterAlertsDataCount = (data)=>async(dispatch)=>{
    dispatch({
        type:e_meterAlertsConstant.METER_ALERTS_SUCCESS,
        data:data,

    })
}
    export const e_updateDotApiCount=(data)=>async(dispatch)=>{
        dispatch({
            type:e_meterAlertsConstant.UPDATE_COUNT,
            data:data,
        })
}
